// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UbT7","title":"styles_title__3HrI8"};